import i18n from '@/utils/i18n';
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0;
}

/*
 * 校验身份证
 * */
export function validIdentifyCard(cardNumber) {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(cardNumber);
}

/*
 * 校验手机号
 * */
export function validMobile(mobile) {
  return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(mobile);
}

/*
 * 是否为预订单
 * */
export function validIsNormalOrder(type) {
  return ['fullDay', 'selfUse', 'free'].includes(type);
}

/**
 * 校验中文姓名
 * @param str
 * @returns {boolean}
 */
export function isCNName(str) {
  return /^[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*$/.test(str);
}

/*
校验手机号
* */
export function validPhone(phone) {
  return /^1[3456789]\d{9}$/.test(phone);
}

/*
校验邮箱
* */
export function validEmail(email) {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
}

//test

/*
e校验邮箱
* */
export function evalidEmail(email) {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
}